// extracted by mini-css-extract-plugin
module.exports = {"navLink__text":"NavLink_navLink__text__zfi3X","container":"MonthSwitcher_container__2ueQN","item":"MonthSwitcher_item__2HxRH"};